import { Items } from './items';

export class Intervents {
  DescrizioneIntervento: string;
  Items: Items[] = [];
}
